import image1 from "../../assets/img/products/Forged-Components Products/Forged-Shafts/steel-pipes-put-together.webp";
import image2 from "../../assets/img/products/Forged-Components Products/Forged-Rings/ss-seamless-forged-rings.webp";
import image3 from "../../assets/img/products/Forged-Components Products/Forged-Flanges/flanges.webp";
import image4 from "../../assets/img/products/Forged-Components Products/Forged-Hubs/forged-hub.webp";
import image99 from "../../assets/img/products/Forged-Components Products/Forged-D-Rings/1.jpg";
import image6 from "../../assets/img/products/Forged-Components Products/Forged-Hooks/view-lifting-hook-industrial-warehouse.webp";
import image7 from "../../assets/img/products/Forged-Components Products/2.png";
import image8 from "../../assets/img/products/Forged-Components Products/1.png";

// Machined Components
import image9 from "../../assets/img/products/Machine-Components-Products/CNC-Turned-Parts/CNC-turning-parts.webp";
import image10 from "../../assets/img/products/Machine-Components-Products/PMC/pc-screen-solar-panels-manufacturing-plant-used-study-solar-energy-systems.webp";
import image11 from "../../assets/img/products/Machine-Components-Products/Shafts/female-mechanic-holding-spare-parts-car.webp";
import image12 from "../../assets/img/products/Machine-Components-Products/Bushes/m-s-bush-500x500.webp";
import image13 from "../../assets/img/products/Machine-Components-Products/Housings/aluminium-bell.jpg";
import image14 from "../../assets/img/products/Machine-Components-Products/Flanges/stainless-steel-flange.webp";
import image15 from "../../assets/img/products/Machine-Components-Products/TC/threadedcomp.webp";
import image16 from "../../assets/img/products/Machine-Components-Products/AMP/various-work-tools-worktop.webp";

//Fasteners

import image17 from "../../assets/img/products/FastenersProduct/High Tensile Bolts/high-tensile-bolts.webp";
import image18 from "../../assets/img/products/FastenersProduct/Nylock Nuts/nyloc-985-zinc.webp";
import image19 from "../../assets/img/products/FastenersProduct/Plain Nuts/cs-nut.webp";
import image20 from "../../assets/img/products/FastenersProduct/Washers/61r7mF8Vs5L._AC_UF1000,1000_QL80_.webp";
import image21 from "../../assets/img/products/FastenersProduct/Studs/stainless-steel-studs.webp";
import image22 from "../../assets/img/products/FastenersProduct/Special Fasteners/types-of-bolts.webp";
import image23 from "../../assets/img/products/FastenersProduct/BlackodisedFasteners/unnamed.webp";
import image24 from "../../assets/img/products/FastenersProduct/Zinc Plated Fasteners/ssfastners.dbc6add91358b56af5af.webp";
import image25 from "../../assets/img/products/FastenersProduct/Hot Dip Galvanized Fasteners/hdg-caoting1.webp";

//Sheet Metal parts

import image26 from "../../assets/img/products/Sheet-Metal-Parts Products/Sheet Metal Braces/71WFmuxYycL.webp";
import image27 from "../../assets/img/products/Sheet-Metal-Parts Products/Covers/Custom-Sheet-Metal-Enclosure-Aluminum-Stainless-Steel-Stamping-Bending-Welding-Laser-Cutting.webp";
import image28 from "../../assets/img/products/Sheet-Metal-Parts Products/Enclosures/enclosure.webp";
import image29 from "../../assets/img/products/Sheet-Metal-Parts Products/Mounting Plates/Custom-Decoration-Items-Steel-Metal-Sheet-Metal-Fabrication-Enclosures-Product-SMP112201-.webp";
import image30 from "../../assets/img/products/Sheet-Metal-Parts Products/Deep Drawn Components/deep-draw-pressed-components.webp";
import image31 from "../../assets/img/products/Sheet-Metal-Parts Products/Laser Cut Parts/parts2.webp";
import image32 from "../../assets/img/products/Sheet-Metal-Parts Products/Fabricated Sheet Metal Assemblies/Sheet-Metal-Enclosure2-scaled.webp";
import image33 from "../../assets/img/products/Sheet-Metal-Parts Products/Fabricated Sheet Metal Assemblies/Sheet-Metal-Enclosure2-scaled.webp";

// Aluminium-extrusion
import image34 from "../../assets/img/products/Aluminium-extrusion/worker-uses-control-joystick-factory.webp";
import image35 from "../../assets/img/products/Aluminium-extrusion/5osiaep1.webp";
import image36 from "../../assets/img/products/Aluminium-extrusion/5osimce.webp";
import image37 from "../../assets/img/products/Aluminium-extrusion/5osisep.webp";
import image38 from "../../assets/img/products/Aluminium-extrusion/5osiea.webp";

// Surface-treated
import image39 from "../../assets/img/products/Surface-treated/6stpmain.webp";
import image40 from "../../assets/img/products/Surface-treated/6osihdp.webp";
import image41 from "../../assets/img/products/Surface-treated/6osiha.webp";
import image42 from "../../assets/img/products/Surface-treated/6osica.webp";
import image43 from "../../assets/img/products/Surface-treated/6osizp.webp";
import image44 from "../../assets/img/products/Surface-treated/6osicp.webp";
import image45 from "../../assets/img/products/Surface-treated/6osipc.webp";

// Fabrication
import image46 from "../../assets/img/products/Fabrication/4-ms-machine-frame-fabrication.webp";
import image47 from "../../assets/img/products/Fabrication/7osibs.webp";
import image48 from "../../assets/img/products/Fabrication/7osisf.webp";
import image49 from "../../assets/img/products/Fabrication/Stainless-Steel-Triangle-Bracket-Laminate-TV-Support-Shelf-Partition-Mount-Wall-Bracket-Hardware (2).avif";
import image50 from "../../assets/img/products/Sheet-Metal-Parts Products/Sheet-Metal-Parts Products/sheet.webp";

// Stainless Steel
import image51 from "../../assets/img/products/Stainless-steel/fabricated-parts.png";
import image52 from "../../assets/img/products/Stainless-steel/8osissm.webp";
import image53 from "../../assets/img/products/Stainless-steel/8osissf.webp";
import image54 from "../../assets/img/products/Forged-Components Products/Forged-D-Rings/1.jpg";
import image55 from "../../assets/img/products/Stainless-steel/8osissm.webp";

// Lashing-Lifting

// import image56 from "../../assets/img/products/";
import image57 from "../../assets/img/products/Lashing-lifting/9fdr.webp";
import image58 from "../../assets/img/products/Lashing-lifting/Ratchets/ratchets-and-sockets-sizes-types-and-uses-section-1.webp";
import image59 from "../../assets/img/products/Lashing-lifting/9buck.webp";
import image60 from "../../assets/img/products/Lashing-lifting/9hoooks.webp";
import image61 from "../../assets/img/products/Lashing-lifting/9osish.webp";
import image62 from "../../assets/img/products/Lashing-lifting/9lb.webp";
// import image63 from "../../assets/img/products/Lashing-lifting/9lc.webp";
import image100 from "../../assets/img/products/Lashing-lifting/9lb.webp";

const productsData = [
  // Forged Components
  {
    id: 1,
    title: "Forged Shafts",
    categoryImage: image100,
    Image: image1,
    category: "forged-components",
    slug: "forged-shafts",
  },
  {
    id: 2,
    title: "Forged Rings",
    Image: image2,
    category: "forged-components",
    slug: "forged-rings",
  },
  {
    id: 3,
    title: "Forged Flanges",
    Image: image3,
    category: "forged-components",
    slug: "forged-flanges",
  },
  {
    id: 4,
    title: "Forged Hubs",
    Image: image4,
    category: "forged-components",
    slug: "forged-hubs",
  },
  {
    id: 5,
    title: "Forged D Rings",
    Image: image99,
    category: "forged-components",
    slug: "forged-d-rings",
  },
  {
    id: 6,
    title: "Forged Hooks",
    category: "forged-components",
    Image: image6,
    slug: "forged-hooks",
  },
  {
    id: 7,
    title: "Automotive Forged Components",
    category: "forged-components",
    Image: image7,
    slug: "automotive-forged-components",
  },
  {
    id: 8,
    title: "Special Forged Parts",
    category: "forged-components",
    Image: image8,
    slug: "special-forged-parts",
  },

  // Machined Components
  {
    id: 9,
    title: "CNC Turned Parts",
    category: "machined-components",
    Image: image9,
    categoryImage: image7,
    slug: "cnc-turned-parts",
  },
  {
    id: 10,
    title: "Precision Machined Components",
    category: "machined-components",
    Image: image10,
    slug: "precision-machined-components",
  },
  {
    id: 11,
    title: "Shafts",
    category: "machined-components",
    Image: image11,
    slug: "shafts",
  },
  {
    id: 12,
    title: "Bushes",
    category: "machined-components",
    Image: image12,
    slug: "bushes",
  },
  {
    id: 13,
    title: "Housings",
    category: "machined-components",
    Image: image13,
    slug: "housings",
  },
  {
    id: 14,
    title: "Flanges",
    category: "machined-components",
    Image: image14,
    slug: "machined-flanges",
  },
  {
    id: 15,
    title: "Threaded Components",
    category: "machined-components",
    Image: image15,
    slug: "threaded-components",
  },
  {
    id: 16,
    title: "Automotive Machined Parts",
    category: "machined-components",
    Image: image16,
    slug: "automotive-machined-parts",
  },

  // Fasteners
  {
    id: 17,
    title: "High Tensile Bolts",
    category: "fasteners",
    Image: image17,
    slug: "high-tensile-bolts",
  },
  {
    id: 18,
    title: "Nylock Nuts",
    category: "fasteners",
    Image: image18,
    slug: "nylock-nuts",
  },
  {
    id: 19,
    title: "Plain Nuts",
    category: "fasteners",
    Image: image19,
    slug: "plain-nuts",
  },
  {
    id: 20,
    title: "Washers",
    category: "fasteners",
    Image: image20,
    slug: "washers",
  },
  {
    id: 21,
    title: "Studs",
    category: "fasteners",
    Image: image21,
    slug: "studs",
  },
  {
    id: 22,
    title: "Special Fasteners",
    category: "fasteners",
    Image: image22,
    slug: "special-fasteners",
  },
  {
    id: 23,
    title: "Blackodised Fasteners",
    category: "fasteners",
    Image: image23,
    slug: "blackodised-fasteners",
  },
  {
    id: 24,
    title: "Zinc Plated Fasteners",
    category: "fasteners",
    Image: image24,
    slug: "zinc-plated-fasteners",
  },
  {
    id: 25,
    title: "Hot Dip Galvanized Fasteners",
    category: "fasteners",
    Image: image25,
    slug: "hot-dip-galvanized-fasteners",
  },

  // Sheet Metal Parts
  {
    id: 26,
    title: "Sheet Metal Brackets",
    category: "sheet-metal-parts",
    Image: image26,
    slug: "sheet-metal-brackets",
  },
  {
    id: 27,
    title: "Covers",
    category: "sheet-metal-parts",
    Image: image27,
    slug: "covers",
  },
  {
    id: 28,
    title: "Enclosures",
    category: "sheet-metal-parts",
    Image: image28,
    slug: "enclosures",
  },
  {
    id: 29,
    title: "Mounting Plates",
    category: "sheet-metal-parts",
    Image: image29,
    slug: "mounting-plates",
  },
  {
    id: 30,
    title: "Deep Drawn Components",
    category: "sheet-metal-parts",
    Image: image30,
    slug: "deep-drawn-components",
  },
  {
    id: 31,
    title: "Laser Cut Parts",
    category: "sheet-metal-parts",
    Image: image31,
    slug: "laser-cut-parts",
  },
  {
    id: 32,
    title: "Fabricated Sheet Metal Assemblies",
    category: "sheet-metal-parts",
    Image: image32,
    slug: "fabricated-sheet-metal-assemblies",
  },

  // Aluminium Extrusion
  {
    id: 33,
    title: "Aluminium Extrusion Profiles",
    category: "aluminium-extrusion",
    Image: image33,
    slug: "aluminium-extrusion-profiles",
  },
  {
    id: 34,
    title: "Machined Extrusion Components",
    category: "aluminium-extrusion",
    Image: image34,
    slug: "machined-extrusion-components",
  },
  {
    id: 35,
    title: "Structural Extrusion Parts",
    category: "aluminium-extrusion",
    Image: image35,
    slug: "structural-extrusion-parts",
  },
  {
    id: 36,
    title: "Extrusion Assemblies",
    category: "aluminium-extrusion",
    Image: image36,
    slug: "extrusion-assemblies",
  },

  // Surface Treatment
  {
    id: 37,
    title: "Hard Anodizing",
    category: "surface-treated",
    Image: image37,
    slug: "hard-anodizing",
  },
  {
    id: 38,
    title: "Color Anodizing",
    category: "surface-treated",
    Image: image38,
    slug: "color-anodizing",
  },
  {
    id: 39,
    title: "Zinc Plating",
    category: "surface-treated",
    Image: image39,
    slug: "zinc-plating",
  },
  {
    id: 40,
    title: "Hot Dip Galvanizing",
    category: "surface-treated",
    Image: image40,
    slug: "hot-dip-galvanizing",
  },
  {
    id: 41,
    title: "Chrome Plating",
    category: "surface-treated",
    Image: image41,
    slug: "chrome-plating",
  },
  {
    id: 42,
    title: "Powder Coating",
    category: "surface-treated",
    Image: image42,
    slug: "powder-coating",
  },
  {
    id: 43,
    title: "Painting",
    category: "surface-treated",
    Image: image43,
    slug: "painting",
  },

  // Fabrication
  {
    id: 44,
    title: "Welded Assemblies",
    category: "fabrication",
    Image: image44,
    slug: "welded-assemblies",
  },
  {
    id: 45,
    title: "Fabricated Structures",
    category: "fabrication",
    Image: image45,
    slug: "fabricated-structures",
  },
  {
    id: 46,
    title: "Machine Frames",
    category: "fabrication",
    Image: image46,
    slug: "machine-frames",
  },
  {
    id: 47,
    title: "Brackets & Supports",
    category: "fabrication",
    Image: image47,
    slug: "brackets-supports",
  },
  {
    id: 48,
    title: "Structural Fabrication",
    category: "fabrication",
    Image: image48,
    slug: "structural-fabrication",
  },

  // Stainless Steel
  {
    id: 49,
    title: "Stainless Steel Machined Parts",
    category: "stainless-steel",
    Image: image49,
    slug: "stainless-steel-machined-parts",
  },
  {
    id: 50,
    title: "Stainless Steel Sheet Parts",
    category: "stainless-steel",
    Image: image50,
    slug: "stainless-steel-sheet-parts",
  },
  {
    id: 51,
    title: "Stainless Steel Fabricated Parts",
    category: "stainless-steel",
    Image: image51,
    slug: "stainless-steel-fabricated-parts",
  },
  {
    id: 52,
    title: "Laser Cut Stainless Steel Components",
    category: "stainless-steel",
    Image: image52,
    slug: "laser-cut-stainless-steel-components",
  },

  // Lifting Products
  {
    id: 53,
    title: "Weld D Rings",
    category: "lashing-lifting",
    Image: image53,
    slug: "weld-d-rings",
  },
  {
    id: 54,
    title: "Forged D Rings",
    category: "lashing-lifting",
    Image: image54,
    slug: "forged-d-rings-lifting",
  },
  {
    id: 55,
    title: "Weld D Rings",
    category: "lashing-lifting",
    Image: image55,
    slug: "ratchets",
  },
  // {
  //   id: 56,
  //   title: "Forged D Rings",
  //   category: "lashing-lifting",
  //   // Image: image56,
  //   slug: "buckles",
  // },
  {
    id: 57,
    title: "Ratchets",
    category: "lashing-lifting",
    Image: image57,
    slug: "hooks",
  },
  {
    id: 58,
    title: "Buckles",
    category: "lashing-lifting",
    Image: image58,
    slug: "snap-hooks",
  },
  {
    id: 59,
    title: "Hooks",
    category: "lashing-lifting",
    Image: image59,
    slug: "lashing-belts",
  },
  {
    id: 60,
    title: "Snap Hooks",
    category: "lashing-lifting",
    Image: image60,
    slug: "lifting-components",
  },
  {
    id: 61,
    title: "Lashing Belt",
    category: "lashing-lifting",
    Image: image61,
    slug: "lifting-components",
  },
  {
    id: 62,
    title: "Lifting Components",
    category: "lashing-lifting",
    Image: image62,
    slug: "lifting-components",
  },
];

export default productsData;
